// extracted by mini-css-extract-plugin
export var image = "image-grN";